<template>
	<a-row>
		<UserTitle class="mb-3" />

		<a-col :span="24">
			<UserData />
			<UserPassword />
		</a-col>
	</a-row>
</template>

<script>
import UserTitle from '@/components/widgets/User/Title'

import UserData from '@/components/widgets/User/Data'
import UserPassword from '@/components/widgets/User/Password'
export default {
	components: {
		UserTitle,
		UserData,
		UserPassword,
	},
}
</script>
